export const PAGE_SIZE = 10;
export const USER_DATA = "userData";
export const USER_ROLE = "userRole";
export const RESPONSE = {
  success: "SUCCESS",
  failure: "FAILURE",
  expired: "EXPIRED",
};

export const QUERY_PARAMS_ITEMS = {
  workflow: "workflow",
  isLogin: "is-login",
  isResetPassword: "is-reset-password",
};

export const PROPERTY_STATUS = {
  basicInfo: "isBasicInfoCompleted",
  neighbourhood: "isNeighbourhoodCompleted",
  socialInfra: "isSocialInfrastructureCompleted",
  connectivity: "isConnectivityCompleted",
  // designAnalysis: "isDesignAnalysisCompleted",
  masterPlan: "isMasterPlanCompleted",
  siteChallanges: "isSiteChallengesCompleted",
  towerUnitPlan: "isTowerUnitPlanCompleted",
  // unitDetails: "",
  specifications: "isSpecificationCompleted",
  amenities: "isAmenitiesCompleted",
  pricing: "isPricingCompleted",
  compliance: "isCompliancesCompleted",
  legal: "isLegalCompleted",
  drafted: "isDrafted",
  published: "isPublished",
};

export const PLOT = "plot";
export const VILLA = "villa";

export const DEVELOPER_PRIORITES = [
  { label: "High", value: "high" },
  { label: "Medium", value: "med" },
  { label: "Low", value: "low" },
];

export const ROLES = {
  superadmin: "superadmin",
  admin: "admin",
  maker: "maker",
  checker: "checker",
};

export const PROPERTY_PUBLISH_STATUS = {
  drafted: "drafted",
  progress: "in-progress",
  completed: "completed",
  published: "published",
  unpublished: "unpublished",
  revert: "reverted",
};
